// Visitor-facing currency display for credit packs.
// Prices come from the API in the base currency (EUR by default). We show an
// approximate amount in the visitor's local currency to reduce purchase friction;
// the actual charge stays in the base currency (clearly noted in the UI).

export const CUR_RATES = { eur: 1, usd: 1.08, gbp: 0.85, chf: 0.96, cad: 1.47 };
export const CUR_LABELS = { eur: "EUR", usd: "USD", gbp: "GBP", chf: "CHF", cad: "CAD" };
const FLAG_CC = { eur: "eu", usd: "us", gbp: "gb", chf: "ch", cad: "ca" };
const STORAGE_KEY = "imperium-cur";

// Locale region -> supported currency
const REGION_CUR = { US: "usd", GB: "gbp", UK: "gbp", CH: "chf", CA: "cad" };

function regionFrom(locale) {
  const m = /[-_]([A-Za-z]{2})\b/.exec(locale || "");
  return m ? m[1].toUpperCase() : null;
}

export function detectCurrency() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && CUR_RATES[saved]) return saved;
    const list = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ""];
    for (const l of list) {
      const r = regionFrom(l);
      if (r && REGION_CUR[r]) return REGION_CUR[r];
    }
  } catch { /* noop */ }
  return "eur";
}

export function saveCurrency(cur) {
  try { localStorage.setItem(STORAGE_KEY, cur); } catch { /* noop */ }
}

export const curFlag = (cur) => `https://flagcdn.com/${FLAG_CC[cur] || "eu"}.svg`;

// Format an EUR-base amount into the chosen currency.
export function fmtCur(amountEur, cur = "eur") {
  const v = (Number(amountEur) || 0) * (CUR_RATES[cur] || 1);
  const n = v.toFixed(2);
  switch (cur) {
    case "usd": return `$${n}`;
    case "gbp": return `£${n}`;
    case "cad": return `C$${n}`;
    case "chf": return `CHF ${n}`;
    default: return `${n}€`;
  }
}
